import mongoose from 'mongoose';
import { customerSchema } from '@/modules/customer/schema/base.schema';
import { projectSaleSchema, propertySaleSchema } from '@/modules/customer/schema/sale.schema';
import { ICustomerDoc, ICustomerModel } from './customer.interface';

export const Customer = mongoose.model<ICustomerDoc, ICustomerModel>(
  'Customer',
  customerSchema,
);

const salesPath = Customer.schema.path(
  'sales',
) as mongoose.Schema.Types.DocumentArray;

salesPath.discriminator('Project', projectSaleSchema);
salesPath.discriminator('Property', propertySaleSchema);

